import { WireWithdrawRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useWireWithdraw() {
  const [withdrawingWire, setWithdrawingWire] = useState(false);

  async function wireWithdraw(params: WireWithdrawRequest) {
    try {
      setWithdrawingWire(true);
      const res = await api.wireWithdraw(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setWithdrawingWire(false);
    }
  }

  return { withdrawingWire, wireWithdraw };
}
